

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Number from "@/shared/filters/Number";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import InspectionCostPage from "@/page/user/InspectionCostPage.vue";


@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    TopBarTitle
  }
})
export default class EstimateInspectionCostComponent extends InspectionCostPage {
  isModeModal: boolean = true;
  isModeQuick: boolean = false;

  onConfirm() {
    let isConfirmCopied: any = 1;
    this.confirm(isConfirmCopied);
    let data = {
      isHikazei: 0, // this.costData.isHikazei, 2021-08-23 sh ひとまず、課税、非課税の概念はないので、0固定としておく
      shakenHiyous: this.costData.shakenHiyou.items,
      sknUketsukeUserJouhou: {
        isConfirmHiyou: isConfirmCopied
      },
      sknUketsukeExtendsId: this.uketsukeExtendsId
    };
    this.$set(this, "updating", true);
    this.reqService.saveShohiyou(data).then( // sendSocket:15車検諸費用の編集
      (res: any) => {
        this.isChangeShohiyou = false;
        this.$set(this, "updating", false);
        this.updateShakenHiyou(res);
      },
      (error: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
        /** #7620の修正を反映させる */
        // if (this.isMadoguchiInshidaiChecked) {
        if (this.isMadoguchiInshidaiChecked || this.isInshidaiZero) {
        /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
        /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
        /** 2021-10-29 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-29 sh #7438 implements tech info amount. [END] */
        this.saveTaxAndRefresh(data);
      }
    });
  }

  // extends元との変更個所を減らす
  updateKensaHiyouPM(data: any) {
    let promise = new Promise((resolve, reject) => {
      this.reqService.updateKensaHiyou(data).then( // sendSocket:17車検検査費用と車検基本費用の編集
        (res: any) => {
          this.isEditKensaHiyou = false;
          this.isEditKensaHiyouNex = false;
          const userService = new UserService();
          userService.getShohiyou();
        },
        (error: any) => {
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          reject();
        }
      );
    });
    return promise;
  }

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
  onUpdateShohiyou() {
    const userService = new UserService();
    userService.getShohiyou();
  }
  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
  showTaxDialog() {
    this.onShowTax(true);
  }
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */

  // クラス継承(extends)元のonShowTax()実行後に呼ばれる拡張処理
  onShowTaxExtend() {
  //  this.$emit("finishedDialogTax"); // 法定費用 車検諸費用ウインドウは閉じる
  }
}
